/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { deviceIntegrationsListManagedDevices } from "../funcs/deviceIntegrationsListManagedDevices.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import {
  ListManagedDevicesRequest,
  ListManagedDevicesResponse,
  ListManagedDevicesSecurity,
  QueryParamCoverageBucket,
  QueryParamPolicyState,
} from "../models/operations/listmanageddevices.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";
import { pageIteratorToJSON } from "./_types.js";
export type ManagedDevicesQueryData = ListManagedDevicesResponse;

export type ManagedDevicesInfiniteQueryData = PageIterator<
  ListManagedDevicesResponse,
  { cursor: string }
>;

export type ManagedDevicesPageParams = PageIterator<
  ListManagedDevicesResponse,
  { cursor: string }
>["~next"];

export function prefetchManagedDevices(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListManagedDevicesRequest | undefined,
  security?: ListManagedDevicesSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildManagedDevicesQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function prefetchManagedDevicesInfinite(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListManagedDevicesRequest | undefined,
  security?: ListManagedDevicesSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchInfiniteQuery({
    ...buildManagedDevicesInfiniteQuery(
      client$,
      request,
      security,
      options,
    ),
    initialPageParam: undefined as ManagedDevicesPageParams,
    getNextPageParam: (previousPage: ManagedDevicesInfiniteQueryData) =>
      previousPage["~next"],
  });
}

export function buildManagedDevicesQuery(
  client$: GramCore,
  request?: ListManagedDevicesRequest | undefined,
  security?: ListManagedDevicesSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<ManagedDevicesQueryData>;
} {
  return {
    queryKey: queryKeyManagedDevices({
      provider: request?.provider,
      coverageBucket: request?.coverageBucket,
      policyState: request?.policyState,
      userIds: request?.userIds,
      userEmails: request?.userEmails,
      cursor: request?.cursor,
      limit: request?.limit,
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
    }),
    queryFn: async function managedDevicesQueryFn(
      ctx,
    ): Promise<ManagedDevicesQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(deviceIntegrationsListManagedDevices(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function buildManagedDevicesInfiniteQuery(
  client$: GramCore,
  request?: ListManagedDevicesRequest | undefined,
  security?: ListManagedDevicesSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext<QueryKey, ManagedDevicesPageParams>,
  ) => Promise<ManagedDevicesInfiniteQueryData>;
} {
  return {
    queryKey: queryKeyManagedDevicesInfinite({
      provider: request?.provider,
      coverageBucket: request?.coverageBucket,
      policyState: request?.policyState,
      userIds: request?.userIds,
      userEmails: request?.userEmails,
      cursor: request?.cursor,
      limit: request?.limit,
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
    }),
    queryFn: async function managedDevicesQuery(
      ctx,
    ): Promise<ManagedDevicesInfiniteQueryData> {
      const sig = combineSignals(ctx.signal, options?.fetchOptions?.signal);
      const mergedOptions = {
        ...options,
        fetchOptions: { ...options?.fetchOptions, signal: sig },
      };

      if (!ctx.pageParam) {
        const pageResult = await unwrapResultIterator(
          deviceIntegrationsListManagedDevices(
            client$,
            request,
            security,
            mergedOptions,
          ),
        );
        return pageIteratorToJSON(pageResult);
      }
      const pageResult = await unwrapResultIterator(
        deviceIntegrationsListManagedDevices(
          client$,
          {
            ...request!,
            cursor: ctx.pageParam.cursor,
          },
          security,
          mergedOptions,
        ),
      );
      return pageIteratorToJSON(pageResult);
    },
  };
}

export function queryKeyManagedDevices(
  parameters: {
    provider?: string | undefined;
    coverageBucket?: QueryParamCoverageBucket | undefined;
    policyState?: QueryParamPolicyState | undefined;
    userIds?: Array<string> | undefined;
    userEmails?: Array<string> | undefined;
    cursor?: string | undefined;
    limit?: number | undefined;
    gramKey?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "deviceIntegrations",
    "listManagedDevices",
    parameters,
  ];
}

export function queryKeyManagedDevicesInfinite(
  parameters: {
    provider?: string | undefined;
    coverageBucket?: QueryParamCoverageBucket | undefined;
    policyState?: QueryParamPolicyState | undefined;
    userIds?: Array<string> | undefined;
    userEmails?: Array<string> | undefined;
    cursor?: string | undefined;
    limit?: number | undefined;
    gramKey?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "deviceIntegrations",
    "listManagedDevices",
    "infinite",
    parameters,
  ];
}
